import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Nav from './Nav'
import { fetchDocCollection, setID } from '../actions'

const ICON_USER = (
    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path
            fillRule="evenodd"
            d="M10 10a4 4 0 100-8 4 4 0 000 8zm-7 8a7 7 0 1114 0H3z"
            clipRule="evenodd"
        />
    </svg>
);

const ICON_BACK = (
    <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
        <path
            fillRule="evenodd"
            d="M12.7 4.3a1 1 0 010 1.4L8.4 10l4.3 4.3a1 1 0 01-1.4 1.4l-5-5a1 1 0 010-1.4l5-5a1 1 0 011.4 0z"
            clipRule="evenodd"
        />
    </svg>
);

const ICON_LOCK = (
    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path
            fillRule="evenodd"
            d="M5 9V7a5 5 0 1110 0v2h.5A1.5 1.5 0 0117 10.5v6A1.5 1.5 0 0115.5 18h-11A1.5 1.5 0 013 16.5v-6A1.5 1.5 0 014.5 9H5zm2 0h6V7a3 3 0 10-6 0v2z"
            clipRule="evenodd"
        />
    </svg>
);

const ICON_BANK = (
    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path d="M10 1 1 5v2h18V5l-9-4zM3 8v7H1v2h18v-2h-2V8h-2v7h-2V8h-2v7H8V8H6v7H4V8H3z" />
    </svg>
);

export class ClientBankStatements extends Component {

    constructor(props) {
        super(props)

        this.state = {
            active_applicant: null
        }
    }

    componentDidMount() {
        // this.fetchDocumentCollections()
        this.props.fetchDocCollection(this.props.match.params.id)
        this.props.setID(this.props.match.params.id)
    }


    // illion — one card per applicant, each opening the embedded portal.
    renderIllionApplicants = () => {
        const applicants = []
        if (this.props.bankstatements.data != null) {
            Object.keys(this.props.bankstatements.data.applicants).forEach((key) => {
                const a = this.props.bankstatements.data.applicants[key];
                applicants.push(
                    <section
                        key={key}
                        className="rounded-2xl bg-white shadow-sm border border-[#E5E7EB] p-5 sm:p-6"
                    >
                        <header className="flex items-start gap-3 mb-4">
                            <span
                                className="inline-flex items-center justify-center h-10 w-10 rounded-xl flex-shrink-0"
                                style={{ backgroundColor: '#EFEAFE', color: '#5B3FE0' }}
                            >
                                {ICON_USER}
                            </span>
                            <div className="flex-1 min-w-0">
                                <h3 className="text-base sm:text-lg font-bold text-[#1F2937]">
                                    {a.name}
                                </h3>
                                <p className="mt-1 text-sm text-[#6B7280] leading-relaxed">
                                    Use the secure link below to share your statements directly
                                    from your bank, built in partnership with the banks for
                                    loan applications.
                                </p>
                            </div>
                        </header>

                        <button
                            type="button"
                            onClick={() => { this.setState({ active_applicant: key }) }}
                            className="w-full sm:w-auto inline-flex items-center justify-center rounded-xl px-6 py-3 text-sm font-semibold text-white shadow-md transition-transform active:scale-95"
                            style={{ backgroundColor: '#7C5CFC' }}
                        >
                            Start Bank Statement Collection →
                        </button>
                    </section>
                )
            })
        }
        return applicants
    }

    // Frollo — a single card linking out to Frollo's hosted registration page.
    // Frollo sends X-Frame-Options: SAMEORIGIN, so (unlike illion) it can't be
    // embedded in an iframe and must open in a new tab.
    renderFrollo = () => {
        const url = this.props.bankstatements.frollo_register_url
        return (
            <section
                key="frollo"
                className="rounded-2xl bg-white shadow-sm border border-[#E5E7EB] p-5 sm:p-6"
            >
                <header className="flex items-start gap-3 mb-4">
                    <span
                        className="inline-flex items-center justify-center h-10 w-10 rounded-xl flex-shrink-0"
                        style={{ backgroundColor: '#EFEAFE', color: '#5B3FE0' }}
                    >
                        {ICON_BANK}
                    </span>
                    <div className="flex-1 min-w-0">
                        <h3 className="text-base sm:text-lg font-bold text-[#1F2937]">
                            Connect your bank with Frollo
                        </h3>
                        <p className="mt-1 text-sm text-[#6B7280] leading-relaxed">
                            We've partnered with Frollo to securely collect your bank data.
                            Create a free Frollo account with Google or your email, then choose
                            which accounts to share. Your bank login is never shared with us.
                        </p>
                    </div>
                </header>

                <a
                    href={url || undefined}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="w-full sm:w-auto inline-flex items-center justify-center rounded-xl px-6 py-3 text-sm font-semibold text-white shadow-md transition-transform active:scale-95"
                    style={{ backgroundColor: '#7C5CFC', opacity: url ? 1 : 0.5, pointerEvents: url ? 'auto' : 'none' }}
                >
                    Connect with Frollo →
                </a>

                <p className="mt-3 text-xs text-[#6B7280]">
                    Opens in a new tab. Once you've connected, we're notified automatically —
                    there's nothing more to do here.
                </p>
            </section>
        )
    }

    renderContent = () => {
        const provider = this.props.bankstatements.provider || 'illion'
        const showIllion = provider === 'illion' || provider === 'both'
        const showFrollo = provider === 'frollo' || provider === 'both'

        if (this.state.active_applicant == null) {
            return (
                <div className="space-y-4 sm:space-y-5">
                    {showIllion ? this.renderIllionApplicants() : null}
                    {showFrollo ? this.renderFrollo() : null}
                </div>
            )
        } else {
            var code = this.props.bankstatements.data.applicants[this.state.active_applicant].code
            const a = this.props.bankstatements.data.applicants[this.state.active_applicant];

            return (
                <div className="space-y-5 sm:space-y-6">
                    <button
                        type="button"
                        onClick={() => { this.setState({ active_applicant: null }) }}
                        className="inline-flex items-center gap-1.5 text-sm font-semibold transition-colors"
                        style={{ color: '#5B3FE0' }}
                    >
                        {ICON_BACK} Back to applicants
                    </button>

                    <section className="rounded-2xl bg-white shadow-sm border border-[#E5E7EB] p-5 sm:p-6">
                        <header className="flex items-start gap-3 mb-4">
                            <span
                                className="inline-flex items-center justify-center h-10 w-10 rounded-xl flex-shrink-0"
                                style={{ backgroundColor: '#EFEAFE', color: '#5B3FE0' }}
                            >
                                {ICON_LOCK}
                            </span>
                            <div className="flex-1 min-w-0">
                                <h3 className="text-base sm:text-lg font-bold text-[#1F2937]">
                                    Providing your income and expenses couldn't be easier
                                </h3>
                                <p className="mt-1 text-xs text-[#5B3FE0] font-semibold">
                                    {a && a.name}
                                </p>
                            </div>
                        </header>

                        <div className="space-y-3 text-sm text-[#6B7280] leading-relaxed">
                            <p>
                                We've partnered with{' '}
                                <a
                                    href="https://www.illion.com.au/"
                                    target="_blank"
                                    rel="noreferrer noopener"
                                    className="font-semibold underline"
                                    style={{ color: '#5B3FE0' }}
                                >
                                    illion
                                </a>{' '}
                                to get your bank statements directly from your bank, so you
                                don't have to download them one by one. We collect 6 months of
                                statements.
                            </p>
                            <p className="text-[#1F2937] font-semibold">
                                Your login details are never stored and are securely discarded
                                once they have been encrypted and passed to the financial
                                institution.
                            </p>
                            <p className="text-[#1F2937] font-semibold">
                                Please ensure you upload all your accounts (transaction
                                accounts, savings accounts, loan accounts, credit card
                                facilities, personal loan facilities, etc.), even if they
                                aren't used.
                            </p>
                            <p className="text-[#1F2937] font-semibold">
                                Should you have accounts with multiple institutions, simply
                                complete the verification process with each institution.
                            </p>
                            <p>
                                This is a one-time service and only happens with your consent.
                                To continue please agree to the user terms / conditions and
                                privacy policy in the next step.
                            </p>
                        </div>
                    </section>

                    <section className="rounded-2xl bg-white shadow-sm border border-[#E5E7EB] overflow-hidden">
                        <iframe
                            src={`https://bankstatements.com.au/iframe/start/FTVH-${code}`}
                            title="Bank statement collection"
                            className="w-full block"
                            style={{ minHeight: '720px', border: 0 }}
                        />
                    </section>
                </div>
            )
        }
    }

    render() {
        return (
            <div
                className="min-h-screen w-full"
                style={{ backgroundColor: '#F5F6FA' }}
            >
                <Helmet>
                    {/*
                      Toggle the modern-page body styles via <html
                      className>. See client/src/index.css ".lg-modern-page"
                      rules - they override the legacy /css/loader.css
                      (which forces html/body to 100px), hide the
                      .full-loader overlay, and set the modern background
                      + font. Using <html> attributes (instead of an
                      inline <style> tag) ensures react-helmet@6.1
                      correctly REMOVES them on unmount so they don't
                      leak into /admin pages.
                    */}
                    <html className="lg-modern-page" />
                    <title>Bank Statements - LoanGateway</title>
                    <meta name="viewport" content="width=device-width, initial-scale=1" />
                </Helmet>
                <Nav showProgress="false"></Nav>

                <main className="px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
                    <div className="max-w-3xl mx-auto">
                        <Link
                            to={`/dashboard/${this.props.match.params.id}`}
                            className="inline-flex items-center gap-1.5 rounded-full bg-white border border-[#E5E7EB] px-3 py-1.5 text-xs sm:text-sm font-semibold transition-all hover:border-[#C4B5FD] hover:shadow-sm mb-5"
                            style={{ color: '#1F2937' }}
                        >
                            <svg className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" style={{ color: '#5B3FE0' }}>
                                <path
                                    fillRule="evenodd"
                                    d="M12.7 4.3a1 1 0 010 1.4L8.4 10l4.3 4.3a1 1 0 01-1.4 1.4l-5-5a1 1 0 010-1.4l5-5a1 1 0 011.4 0z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            Back to dashboard
                        </Link>

                        <div className="mb-6 sm:mb-8">
                            <p
                                className="text-xs sm:text-sm font-semibold tracking-wide uppercase"
                                style={{ color: '#5B3FE0' }}
                            >
                                Your application
                            </p>
                            <h1 className="mt-2 text-2xl sm:text-3xl font-bold text-[#1F2937]">
                                Bank Statements
                            </h1>
                            <p className="mt-2 text-sm sm:text-base text-[#6B7280] leading-relaxed">
                                Securely share your bank statements via our trusted portal.
                                Built in partnership with the banks. Your credentials are
                                never stored.
                            </p>
                        </div>

                        {this.renderContent()}
                    </div>
                </main>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    bankstatements: state.bankstatements
})

const mapDispatchToProps = {
    fetchDocCollection, setID
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientBankStatements)
